import React from "react";
import { useAuth } from "../contexts/AuthContext";

/**
 * Global DEMO ENVIRONMENT banner.
 * Renders a slim, professional strip at the very top of the app whenever the
 * signed-in user is the DerwentAI Demo Account, so demonstration data is never
 * confused with live client information.
 */
export const DemoBanner = () => {
  const { user } = useAuth();
  if (!user?.is_demo) return null;

  return (
    <div
      data-testid="demo-environment-banner"
      className="w-full bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-slate-900 border-b border-amber-600/60"
      style={{ position: "sticky", top: 0, zIndex: 40 }}
    >
      <div className="max-w-screen-2xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 text-xs sm:text-sm font-semibold tracking-wide">
        <span className="inline-flex h-2 w-2 rounded-full bg-slate-900 animate-pulse" />
        <span className="uppercase">DerwentAI Demo Environment</span>
        <span className="hidden sm:inline font-medium text-slate-900/80">
          — demonstration data only. Not live client information.
        </span>
      </div>
    </div>
  );
};

export default DemoBanner;
